import { SuperToastStack } from '@shared/components/SuperToast/SuperToast';

export function ToastProvider() {
  return <SuperToastStack />;
}
